import {
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

export function checkShareAvailability(
  serviceState: AdditionServicesState,
  servicePropertyValueCacheState: AServicePropertyCache,
  servicePropertyFilterAndOderState: AServicePropertyFilterAndOrder
) {
  const selectedVariant = serviceState.Variants.find((v) => v.id === serviceState.SelectedVariant);
  const isShareNotAvailable =
    !selectedVariant ||
    serviceState.IsServicesLoading ||
    serviceState.IsServicesCalculating ||
    !servicePropertyValueCacheState.Options[serviceState.SelectedVariant] ||
    !servicePropertyFilterAndOderState.Variants[serviceState.SelectedVariant];

  return !isShareNotAvailable;
}
